import AppStorage from "./AppStorage";

export default class Connection {

  static server = window.location.hostname;
  //TODO 临时测试域名
  // server = "incentivo-test-backend.lpht.com";
  //TODO 本地
  // server = "127.0.0.1";
  // 线上
  server = "incentivo-backend.lpht.com";
  // static domain = window.location.protocol + "//" + Connection.server + "/";
  // static domain = "https://" + Connection.server + ":8080/";
  // 线上
  static domain = "https://" + Connection.server + "/";
  //TODO 临时测试关闭端口
  //static servicePort = window.location.protocol.indexOf("https") > -1 ? "5001" : "5000";
  // static servicePort = window.location.protocol.indexOf("https") > -1 ? "8081" : "8080";
  // static service = window.location.protocol + "//" + "incentivo.lpht.com" + ":" + Connection.servicePort + "/";
  //TODO 测试
  // static service = "https:" + "//" + "incentivo-test-backend.lpht.com" + "/";
  //TODO 本地
  // static service = "http:" + "//" + "127.0.0.1" + ":8080/";
  //TODO 线上
  static service = "https:" + "//" + "incentivo-backend.lpht.com" + "/";
  static parsed = false;
  static session = null;
  static processing = false;
  static pending = [];

  static ParseAddress(target) {
    if (this.parsed != true && typeof window.AppSettings === "object" && window.AppSettings != null && target.indexOf(this.service > -1)) {
      // var s = window.location.protocol + "//" + (typeof window.AppSettings.serverDomain === "string" ? window.AppSettings.serverDomain : Connection.server) + ":"
      //   + (window.location.protocol.indexOf("https") >= 0 && typeof window.AppSettings.serverHttpsPort === "string" ? window.AppSettings.serverHttpsPort : typeof window.AppSettings.serverPort === "string" ? window.AppSettings.serverPort : Connection.servicePort) + "/";
      //TODO 测试
      // var s = "https://" + "incentivo-test-backend.lpht.com" + "/";
      //TODO 本地
      // var s = "http://" + "127.0.0.1:8080" + "/";
      //TODO 线上
      var s = "https://" + "incentivo-backend.lpht.com" + "/";
      var r = this.service;
      this.service = s;
      if (s != this.service) return target.replace(r, s);
    }
    this.parsed = true;
    return target;
  }

  static Secure(url, parameters, pending_resolve, pending_reject, er) {
    // url = url != null && url.length > 0 ? url : "incentivo-test-backend.lpht.com";
    //本地
    // url = url != null && url.length > 0 ? url : "127.0.0.1:8080";
    //线上
    url = url != null && url.length > 0 ? url : "incentivo-backend.lpht.com";
    url = this.ParseAddress(url);
    var p = global.session != null ?
      {
        "headers": {
          "Origin": window.location.host,
          "session": global.session
        }
      } :
      { "headers": { "Origin": window.location.host } };

    if (parameters != null && typeof parameters === "object")
      p = Connection.extractParameters(parameters, p);
    if (typeof pending_resolve !== "undefined") {
      fetch(url, p).then((response) => {
        if (response.status == 498) {
          pending_reject();
        } else pending_resolve(response);
      }).catch((error) => {
        pending_reject(error);
      });
    } else
      return new Promise((resolve, reject) => {
        //debugger;
        fetch(url, p).then((response) => {
          if (response.status == 498) {
            Connection.pending.push(function (url, parameters, resolve, reject) {
              return function (mode, er) {
                if (mode == false) reject(er);
                else Connection.Secure(url, parameters, resolve, reject, er);
              };
            }(url, parameters, resolve, reject))
            if (!Connection.processing) {
              Connection.processing = true;
              Connection.Revalidate().then(() => {
                while (Connection.pending.length > 0)
                  Connection.pending.shift()(true);
                Connection.processing = false;
              }).catch((er) => {
                while (Connection.pending.length > 0)
                  Connection.pending.shift()(false, er);
                Connection.processing = false;
              });
            }
          } else
            resolve(response);
        }).catch((error) => {
          reject(error);
        });
      }, () => {
      });
  }

  static extractParameters(target, model) {
    var t = {};
    for (var i in target)
      t[i] = target[i];
    for (var i in model)
      if (typeof target[i] === "undefined" || typeof target[i] !== typeof model[i]
        || typeof target[i] !== "object" || target[i] == null) t[i] = model[i];
      else t[i] = Connection.extractParameters(target[i], model[i]);
    return t;
  }


  static Revalidate() {
    return new Promise((resolve, reject) => {
      if (global.token == null) reject();
      fetch(Connection.service + "Revalidate/",
        {
          "headers": {
            "token": global.token,
          }
        }
      ).then((response) => {
        if (response.ok && response.status == 200) {
          response.text().then((data) => {
            AppStorage.SetStorageKey('session', data);
            global.session = data;
            resolve();
          }).catch(() => {
            reject(response);
          });
        } else
          reject(response);
      }).catch(() => {
        reject(null);
      })
    });
  }
}